import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Autocomplete as MUIAutocomplete,
  AutocompleteProps as MUIAutocompleteProps,
  TextFieldProps,
} from '@mui/material';
import classNames from 'classnames';
import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Input from '../Input/Input';
import classes from './Autocomplete.module.scss';

export interface AutocompleteProps<T>
  extends Omit<MUIAutocompleteProps<T, false, false, false>, 'renderInput'> {
  label: string;
  placeholder: string;
  InputProps?: TextFieldProps;
}

const Autocomplete = <T,>({
  label,
  placeholder,
  options,
  InputProps,
  ...props
}: AutocompleteProps<T>): ReactElement => {
  const [isOpen, setIsOpen] = useState(props?.open ?? false);
  const { t } = useTranslation();
  return (
    <MUIAutocomplete
      {...props}
      open={isOpen}
      onClose={() => setIsOpen(false)}
      options={options}
      classes={{
        inputRoot: classNames(classes.InputRoot, {
          [classes.InputOpened]: isOpen,
        }),
        endAdornment: classes.EndAdornment,
        listbox: classes.ListBox,
        paper: classes.ComboBox,
        popper: classes.Popper,
      }}
      noOptionsText={t('common:no_options')}
      popupIcon={<FontAwesomeIcon icon={faChevronDown} />}
      renderInput={(params) => (
        <Input
          {...params}
          {...InputProps}
          className={classNames({ [classes.Input]: isOpen })}
          label={label}
          placeholder={placeholder}
          onClick={() => setIsOpen(true)}
          inputProps={{
            ...params.inputProps,
            ...InputProps?.inputProps,
          }}
        />
      )}
    />
  );
};

export default Autocomplete;
